var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoError = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Infomation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.297,
    height: 22.297,
    viewBox: "0 0 22.297 22.297",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13440",
    "data-name": "Path 13440",
    d: "M26.3,15.149A11.149,11.149,0,1,1,15.149,4,11.149,11.149,0,0,1,26.3,15.149Z",
    transform: "translate(-4 -4)",
    fill: "#FEE2DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13441",
    "data-name": "Path 13441",
    d: "M21.779,18.459h2.23v6.132h-2.23Zm2.508-3.066A1.394,1.394,0,1,1,22.894,14,1.395,1.395,0,0,1,24.287,15.394Z",
    transform: "translate(-11.745 -8.426)",
    fill: "#FC6A61"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info-error.516253b5aedf654a98054dcf433808e6.svg";